import { StyleProvider, createCache } from '@ant-design/cssinjs';
import { createContext, useContext, useMemo } from 'react';

const AntdCacheContext = createContext<ReturnType<typeof createCache> | null>(null);

export function AntdCacheProvider({
  cache,
  children,
}: {
  cache: ReturnType<typeof createCache>;
  children: React.ReactNode;
}) {
  return <AntdCacheContext.Provider value={cache}>{children}</AntdCacheContext.Provider>;
}

export function AntdRegistry({ children }: { children: React.ReactNode }) {
  const provided = useContext(AntdCacheContext);
  const clientCache = useMemo(() => createCache(), []);
  const usedCache = provided ?? clientCache;

  return (
    <StyleProvider cache={usedCache} hashPriority="low">
      {children}
    </StyleProvider>
  );
}
